import React, { useState } from "react";
import "./style.scss";
import RevealAnimation from "../RevealAnimation";
import Button from "../Button";
import RightArrow from "./../../assets/Images/services/massage-chat.png";
import { Link } from "gatsby";
import { Tooltip } from "@material-ui/core";
import OurOfferingLists from "./ourOfferingLists";

function OurOffering({
  title = "",
  details = "",
  CardListData = [],
  pageName = "consult",
  sectionTitle = "",
  listTitle = "",
  hideCTA = false,
}) {
  return (
    <div className="service-offering-wrapper">
      {title && (
        <RevealAnimation
          component={"h2"}
          animation={"slide-left"}
          className="title-header mt-15 title-underline"
        >
          {title}
        </RevealAnimation>
      )}
      {details && (
        <div className="offer-content mt-30">
          <p className="offer-details-heading">{details}</p>
        </div>
      )}

      <OurOfferingLists
        listTitle={listTitle}
        CardListData={CardListData}
        pageName={pageName}
        sectionTitle={sectionTitle}
        hideCTA={hideCTA}
      />
    </div>
  );
}

export default OurOffering;
